'use client';

import { c as _c } from "react/compiler-runtime";
import { Chip } from '@common/components';
import { SvgDonationTax, SvgWelmarket } from '@common/icon';
export type ReviewFilter = 'donation' | 'local-market';
interface ReviewFilterChipsProps {
  value: ReviewFilter;
  onChange: (value: ReviewFilter) => void;
}
export const ReviewFilterChips = t0 => {
  const $ = _c(15);
  const {
    value,
    onChange
  } = t0;
  const t1 = value === "donation";
  let t2;
  if ($[0] !== onChange) {
    t2 = () => onChange("donation");
    $[0] = onChange;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <SvgDonationTax originalFill={true} className="mr-4 size-15" />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t1 || $[4] !== t2) {
    t4 = <Chip theme="primary" checked={t1} onCheckedChange={t2}>{t3}고향사랑기부</Chip>;
    $[3] = t1;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = value === "local-market";
  let t6;
  if ($[6] !== onChange) {
    t6 = () => onChange("local-market");
    $[6] = onChange;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <SvgWelmarket originalFill={true} className="mr-4 size-14" />;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t5 || $[10] !== t6) {
    t8 = <Chip theme="primary" checked={t5} onCheckedChange={t6}>{t7}웰마켙</Chip>;
    $[9] = t5;
    $[10] = t6;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t4 || $[13] !== t8) {
    t9 = <div className="flex gap-6 px-20 py-16">{t4}{t8}</div>;
    $[12] = t4;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  return t9;
};